"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const NewUserSelectionCard = (props) => {
    const { orientation, icon, title, description, onClick } = props;
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('new-user-selection-card', orientation), role: 'button', onClick: onClick }, orientation === 'vertical' ? (react_1.default.createElement("div", { className: "vertical" },
        react_1.default.createElement("img", { src: icon, className: 'card-icon', alt: title }),
        react_1.default.createElement("div", { className: "card-title" }, title),
        react_1.default.createElement("p", { className: "card-description" }, description))) : (react_1.default.createElement("div", { className: "horizontal" },
        react_1.default.createElement("img", { src: icon, className: 'card-icon', alt: title }),
        react_1.default.createElement("div", { className: "card-content" },
            react_1.default.createElement("div", { className: "card-title" }, title),
            react_1.default.createElement("p", { className: "card-description" }, description))))));
};
exports.default = NewUserSelectionCard;
